import connection from '../utils/api';

export const makePayment = (url, payload) => connection.post(url, payload);
export const fetchPackages = () => connection.get(`packages`);
export const fetchFeatures = () => connection.get(`features`);